import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  isConnectedDomain,
  isMediawireDomain,
  isNonRelAttrDomain,
} from 'config/public';
import { isAffiliate, getEncodedAffiliateLink } from 'utils/Affiliate';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';

const isSpotlightLink = linkUrl =>
  linkUrl &&
  linkUrl.includes('/spotlight/') &&
  linkUrl.includes('/articleshow/');

const LinkV2 = props => {
  const { to, children, skipAffiliateHandling, isNoLink } = props;
  const handleClick = () => {
    const { requestIdleCallback = setTimeout } = window;
    requestIdleCallback(() => {
      if (props.data) {
        sendGaThroughProps({ data: props.data });
      }
      if (props.ga4Data && Array.isArray(props.ga4Data)) {
        analyticsWrapper('ga4', ...props.ga4Data);
      }
    }, 0);
  };

  let linkUrl = to || props.href;
  const isAffiliateLink = !skipAffiliateHandling && isAffiliate(linkUrl);
  let nofollow = props.rel || 'noopener nofollow noreferrer';
  const isThisConnectedDomain = isConnectedDomain(linkUrl);
  const isThisNonRelAttrDomain = isNonRelAttrDomain(linkUrl);
  const isToiLink =
    typeof linkUrl === 'string' &&
    (linkUrl.indexOf('timesofindia.indiatimes.com') >= 0 ||
      linkUrl.indexOf('m.timesofindia.com') >= 0 ||
      linkUrl.startsWith('/'));

  if (isToiLink || isThisConnectedDomain || isThisNonRelAttrDomain) {
    if (isMediawireDomain(linkUrl)) {
      nofollow = 'noopener nofollow';
    } else if (props.target === '_blank' && !isThisNonRelAttrDomain) {
      nofollow = 'noopener';
    } else {
      nofollow = undefined;
    }
  }

  if (isAffiliateLink) {
    const isWap = props.isMobile;
    const isMSP = props.isMspArticle;
    nofollow += ' nofollow sponsored';
    linkUrl = getEncodedAffiliateLink('', linkUrl, isWap, isMSP).replace(
      '<title>',
      '',
    );
  }
  if (props.rel && props.rel === 'sponsored noopener') {
    nofollow = 'sponsored noopener';
  }
  if (isSpotlightLink(linkUrl) && nofollow && !nofollow.includes('sponsored')) {
    nofollow += ' sponsored';
  }
  // isToiLink - Overriding target _blank in case toilink | Due to google interstial | overriding props due to props injected on a tag
  let target = props?.target ? props?.target : '';

  if (props.forceTargetBlank) {
    // NOTE:- web interstiatial ads viewability will be affected, only enabled on MSP and hotpicks
    target = '_blank';
  }

  if (isNoLink) {
    return (
      <div {...props} className={props.className} onClick={handleClick}>
        {children}
      </div>
    );
  }
  if (target) {
    return (
      <a
        {...props}
        onClick={props.onClick || handleClick}
        rel={nofollow}
        // eslint-disable-next-line react/no-unknown-property
        frmappuse="1"
        data={undefined}
        ref={props.innerRef}
        target={target}
        href={linkUrl}
      >
        {children}
      </a>
    );
  }
  return (
    <a
      {...props}
      onClick={props.onClick || handleClick}
      rel={nofollow}
      // eslint-disable-next-line react/no-unknown-property
      frmappuse="1"
      data={undefined}
      ref={props.innerRef}
      href={linkUrl}
    >
      {children}
    </a>
  );
};

LinkV2.propTypes = {
  isNoLink: PropTypes.bool,
  route: PropTypes.string,
  doNotChangeURL: PropTypes.bool,
  doNotChangeDomain: PropTypes.bool,
  skipAffiliateHandling: PropTypes.bool,
  rel: PropTypes.string,
  isMobile: PropTypes.bool,
  target: PropTypes.bool,
  isMspArticle: PropTypes.bool,
  forceTargetBlank: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
  extraClick: PropTypes.func,
};

LinkV2.defaultProps = {
  isNoLink: false,
  route: undefined,
  doNotChangeURL: false,
  doNotChangeDomain: false,
  skipAffiliateHandling: false,
  rel: undefined,
  isMobile: false,
  isMspArticle: false,
  forceTargetBlank: false,
  target: '',
  onClick: null,
  to: undefined,
  children: null,
  href: undefined,
  extraClick: null,
};

// export default React.forwardRef(Link);
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

const ConnectedLinkComponent = connect(mapStateToProps)(LinkV2);
export default React.forwardRef((props, ref) => (
  <ConnectedLinkComponent innerRef={ref} {...props} />
));
